import { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent  } from 'reactstrap';
import {Breadcrumbs} from '../../../../AbstractElements';
import {GradeGroup, Hrm, Grade, Step, GradeStep, MaReportClass} from '../../../../Constant';
import {Link} from "react-router-dom";
import {PlusCircle} from "react-feather";
import HrmGradeGroupList from "./FinanceMaReportClass/List/FinanceMaReportClassList";
/* import HrmGradeList from "./Grade/List/HrmGradeList";
import StepList from "./Step/List/StepList";
import GradeStepForm from './GradeStep/GradeStepForm'; */
import useFinanceManagementAccountReportSettings from './controller';

const FinanceManagementAccountReportSettings = () => {
    const {
        layoutURL,
        FINANCE_MA_REPORT_CLASS,
        /* GRADE,
        STEP,
        GRADE_STEP, */
        commissionTab,
        tabDisplayNames,
        handleTabClick
    } = useFinanceManagementAccountReportSettings();
    
    return (
        <Fragment>
            <Breadcrumbs parent={Hrm} title={tabDisplayNames[commissionTab]} mainTitle={tabDisplayNames[commissionTab]}/>
            <Container fluid={true}>
                <Row>
                    <Col sm='12' xl='12' className='xl-100'>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md="6">
                                        {/*<H5>{GradeGroup}</H5>*/}
                                    </Col>
                                    <Col md="6">
                                        <div className="text-end file-content">
                                       {/*  {commissionTab !== `${FINANCE_MA_REPORT_CLASS}` && ( */}
                                            <Link className="btn btn-primary ms-2" style={{color: 'white'}} to={`/finance/settings/${commissionTab}/create/${layoutURL}`}>
                                                <PlusCircle/> New {tabDisplayNames[commissionTab] || 'Item'}
                                            </Link>
                                       {/*  )} */}
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm={'12'}>
                                        <Nav className='border-tab nav-secondary nav-pills' tabs>
                                            <NavItem>
                                                <NavLink href='#' className={commissionTab === `${FINANCE_MA_REPORT_CLASS}` ? 'active' : ''}
                                                         onClick={() => handleTabClick(`${FINANCE_MA_REPORT_CLASS}`)}>
                                                    <i className='icofont icofont-files'></i>
                                                    {MaReportClass}
                                                </NavLink>
                                            </NavItem>
                                           {/*  <NavItem> 
                                                <NavLink href='#' className={commissionTab === `${GRADE}` ? 'active' : ''}
                                                         onClick={() => handleTabClick(`${GRADE}`)}>
                                                    <i className='icofont icofont-files'></i>
                                                    {Grade}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink href='#' className={commissionTab === `${STEP}` ? 'active' : ''}
                                                         onClick={() => handleTabClick(`${STEP}`)}>
                                                    <i className='icofont icofont-files'></i>
                                                    {Step}
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink href='#' className={commissionTab === `${GRADE_STEP}` ? 'active' : ''}
                                                         onClick={() => handleTabClick(`${GRADE_STEP}`)}>
                                                    <i className='icofont icofont-files'></i>
                                                    {GradeStep}
                                                </NavLink>
                                            </NavItem>*/}
                                        </Nav> 
                                        <TabContent activeTab={commissionTab}>
                                            {commissionTab === `${FINANCE_MA_REPORT_CLASS}` && <HrmGradeGroupList name={FINANCE_MA_REPORT_CLASS} />}
                                           {/*  {commissionTab === `${GRADE}` && <HrmGradeList name={GRADE} />}
                                            {commissionTab === `${STEP}` && <StepList name={STEP} />}
                                            {commissionTab === `${GRADE_STEP}` && <GradeStepForm name={GRADE_STEP} />} */}
                                        </TabContent>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}

export default  FinanceManagementAccountReportSettings